import { isAfter, isEqual } from 'date-fns';

export class NextDate extends Date {
  private type: 'NextDate' = 'NextDate';
}

export const is = (v: Date, reference: Date): v is NextDate =>
  isEqual(v, reference) || isAfter(v, reference);
